import { render, staticRenderFns } from "./labelEditor.vue?vue&type=template&id=0efdb5ad&scoped=true"
import script from "./labelEditor.vue?vue&type=script&lang=js"
export * from "./labelEditor.vue?vue&type=script&lang=js"
import style0 from "./labelEditor.vue?vue&type=style&index=0&id=0efdb5ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efdb5ad",
  null
  
)

export default component.exports